import React, {FC, useState, useEffect} from "react"

import {Card} from "@irati/ui/src/Layout"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage from "@irati/utils/lang"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import {Body} from "@irati/ui/src/Typography"
import Loading from "@irati/ui/src/Loading"
import adminReportingService from "@irati/adminReporting/services/adminReporting"
import authentication from "@irati/auth"
import {BusinessStory} from "@irati/types"

import Welcome from "./Welcome"
import SavingsEngagement from "./SavingsEngagement"
import TopRedemptions from "./TopRedemptions"
import Persona from "./Persona"

interface Props {}

const Wrapped: FC<Props> = () => {
  const [load, setLoad] = useState<Promise<any> | null>(null)
  const [businessStory, setBusinessStory] = useState<BusinessStory>()

  const theme = useTheme()

  useEffect(() => {
    const businessId = authentication.business().uuid
    const loaded = adminReportingService.getBusinessStory({businessId}).then((story: BusinessStory) => {
      setBusinessStory(story)
    })
    setLoad(loaded)
  }, [])

  return (
    <Loading load={load}>
      <Card bgColor={theme.colors.primary2}>
        <Welcome />
        {businessStory?.highlights && <SavingsEngagement engagedUsers={businessStory.highlights[0].engagement?.engagedUsers} />}
        <TopRedemptions
          deals={[]} // currently endpoint not supporting for deal variants, just fallback option
          redemptions={businessStory?.persona?.diva?.redemptions}
          savings={businessStory?.persona?.diva?.totalSavingsGbp}
          unique={businessStory?.persona?.diva?.uniqueDeals}
        />
        <Persona
          title="admin.components.yourPerkboxStory.persona.discount.title"
          image="admin.components.yourPerkboxStory.persona.discount.img"
          text={
            <FormattedMessage
              id="admin.components.yourPerkboxStory.persona.discount.text"
              values={{
                unique: (
                  <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                    {businessStory?.persona?.diva?.uniqueDeals}
                  </Body>
                ),
                redemptions: (
                  <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                    {businessStory?.persona?.diva?.redemptions}
                  </Body>
                ),
                savings: (
                  <Body weight="bold" display="inline" color={theme.colors.greys.white}>
                    {formatCurrency({value: businessStory?.persona?.diva?.totalSavingsGbp})}
                  </Body>
                )
              }}
            />
          }
        />
      </Card>
    </Loading>
  )
}

export default Wrapped
